import React from 'react'
import './Footer.css'

const Footer = (props) => {
  return (
    <footer className="footer">
      <div className="container-fixed">

        <nav className="navbar navbar-inverse">
          <div className="container-fluid">
            <div>
              <ul className="nav navbar-nav navbar-right">
                <li><a className="copyright" href="#">Copyright &copy; 2017 Out of Last Place Institute</a></li>
              </ul>
            </div>
          </div>
        </nav>

      </div>
    </footer>
  );
}

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/Footer.js
 **/